import humps from 'humps';
import api from '@/api/api';

export default {
  create(buildSprintProject) {
    const path = '/build_sprint/api/v1/projects';

    return api({
      method: 'post',
      data: humps.decamelizeKeys({ buildSprintProject }),
      url: path,
    });
  },
  update(projectId, buildSprintProject) {
    const path = `/build_sprint/api/v1/projects/${projectId}`;

    return api({
      method: 'patch',
      data: humps.decamelizeKeys({ buildSprintProject }),
      url: path,
    });
  },
};
